import React from "react";
import { useIntl } from "react-intl";
import { Waypoint } from "react-waypoint";
import { SearchInput } from "@shared/ui/Inputs";
import { AssignItemListItem } from "@shared/ui/ListItemCards";
import { NotFoundComponent } from "~/components/_notFoundMessage";
import { MachineLoaderComponent } from "~/components/skeletonLoaders/_machineLoders";
import { ITEMS_BEFORE_PAGE } from "~/constants";
import { NoUserAssignedIcon } from "~/icons/icons";
import { getPartThumbnail } from "~/utils";

import type { AddPartModalProps } from "./types";

const AddPartModal = ({
  allParts,
  selectedParts,
  updateSelectedParts,
  searchQuery,
  setSearchQuery,
  onScrollToBottom,
  partsLoading,
}: AddPartModalProps) => {
  const { messages } = useIntl();

  const handleRowClick = (event: React.MouseEvent, id: string) => {
    event.stopPropagation();

    const index = selectedParts.indexOf(id);

    if (index >= 0) {
      updateSelectedParts((prev) => prev.filter((item) => item !== id));
    } else {
      updateSelectedParts((prev) => [...prev, id]);
    }
  };

  return (
    <>
      <SearchInput
        onChange={setSearchQuery}
        placeholder={messages["hierarchy"]["assets"]["searchParts"]}
        value={searchQuery}
        activeByDefault
        activeClassName="w-full"
        className="mb-md"
      />

      <section>
        <div className="flex justify-between w-full font-manrope font-medium text-xs text-secondary capitalize border-b border-solid border-primary">
          <div className="w-11 py-xs" />
          <div className="py-xs flex-1">{messages?.inventory.partName}</div>
          <div className="w-1/3 py-xs">
            {messages?.inventory?.labels.articleNumber}
          </div>
        </div>

        {!allParts?.length && !partsLoading && (
          <NotFoundComponent icon={<NoUserAssignedIcon />} />
        )}

        {allParts.map((part, index) => (
          <React.Fragment key={part._id}>
            <div onClick={(e) => handleRowClick(e, part._id)}>
              <AssignItemListItem
                isChecked={selectedParts.includes(part._id)}
                name={part.name}
                itemId={part.articleNumber}
                thumbnail={getPartThumbnail(part)}
                visibilityScope={part?.visibilityScope}
              />
            </div>
            {!partsLoading && index === allParts.length - ITEMS_BEFORE_PAGE && (
              <Waypoint onEnter={onScrollToBottom} />
            )}
          </React.Fragment>
        ))}
      </section>

      {partsLoading && <MachineLoaderComponent total={1} />}
    </>
  );
};

export default AddPartModal;
